/**
 * @param {ChildNode} children - child nodes
 * @param {StyleSheet} style - additional style
 * @param {string} align - text align
 * @param {TextDirectionType} direction - container type > horizontal / vertical
 * @returns {React.ReactNode}
 */
import React from 'react';
import { View } from 'react-native';
import { themeForm } from '../../styles';

type TextDirectionType = 'vertical' | 'horizontal';
type TextContainerType = {
  children?: React.ReactNode | React.ReactNode;
  direction?: TextDirectionType;
  align?: string;
};
export const TextContainer = ({ children, direction = 'horizontal', align = 'left' }: TextContainerType) => {
  return (
    <View
      style={[
        themeForm.textContainer,
        direction === 'horizontal' ? themeForm.textContainerHorizontal : themeForm.textContainerVertical,
        align === 'left'
          ? null
          : align === 'center'
          ? themeForm.textContainerAlignCenter
          : themeForm.textContainerAlignRight,
      ]}
    >
      {children}
    </View>
  );
};
